import { render } from "./PromoTable.vue?vue&type=template&id=39448650&scoped=true"
import script from "./PromoTable.vue?vue&type=script&lang=js"
export * from "./PromoTable.vue?vue&type=script&lang=js"

import "./PromoTable.vue?vue&type=style&index=0&id=39448650&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39448650"]])

export default __exports__